var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle3Dots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 0.833252C4.04188 0.833252 0.833252 4.04188 0.833252 7.99992C0.833252 11.958 4.04188 15.1666 7.99992 15.1666C11.958 15.1666 15.1666 11.958 15.1666 7.99992C15.1666 4.04188 11.958 0.833252 7.99992 0.833252ZM1.83325 7.99992C1.83325 4.59416 4.59416 1.83325 7.99992 1.83325C11.4057 1.83325 14.1666 4.59416 14.1666 7.99992C14.1666 11.4057 11.4057 14.1666 7.99992 14.1666C4.59416 14.1666 1.83325 11.4057 1.83325 7.99992Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 7.99992C5.99992 8.36811 5.70144 8.66658 5.33325 8.66658C4.96506 8.66658 4.66658 8.36811 4.66658 7.99992C4.66658 7.63173 4.96506 7.33325 5.33325 7.33325C5.70144 7.33325 5.99992 7.63173 5.99992 7.99992Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66658 7.99992C8.66658 8.36811 8.36811 8.66658 7.99992 8.66658C7.63173 8.66658 7.33325 8.36811 7.33325 7.99992C7.33325 7.63173 7.63173 7.33325 7.99992 7.33325C8.36811 7.33325 8.66658 7.63173 8.66658 7.99992Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 7.99992C11.3333 8.36811 11.0348 8.66658 10.6666 8.66658C10.2984 8.66658 9.99992 8.36811 9.99992 7.99992C9.99992 7.63173 10.2984 7.33325 10.6666 7.33325C11.0348 7.33325 11.3333 7.63173 11.3333 7.99992Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle3Dots);
export default __webpack_public_path__ + "static/media/circle-3-dots.d7e1ab3ac90d5c71dde0fb70875afc1a.svg";
export { ForwardRef as ReactComponent };